(() => {
  const selector = '.lp-faq__item, .lp-pdp__acc-item, .lp-care-page__content details';
  const panelSelector = '.lp-faq__answer, .lp-pdp__acc-body, .lp-care-accordion__body';
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fallbackDuration = 460;

  const resetPanel = (details, panel) => {
    panel.style.height = details.open ? '' : '0px';
    panel.style.opacity = '';
    panel.style.paddingTop = '';
    panel.style.overflow = '';
    delete details.dataset.lpAnimating;
    details.querySelector('summary')?.setAttribute('aria-expanded', String(details.open));
  };

  const finishAfterTransition = (panel, done) => {
    let finished = false;
    const finish = () => {
      if (finished) return;
      finished = true;
      panel.removeEventListener('transitionend', onTransitionEnd);
      window.clearTimeout(timer);
      done();
    };
    const onTransitionEnd = (event) => {
      if (event.target === panel && event.propertyName === 'height') finish();
    };
    const timer = window.setTimeout(finish, fallbackDuration);
    panel.addEventListener('transitionend', onTransitionEnd);
  };

  const openDetails = (details, panel) => {
    details.dataset.lpAnimating = 'true';
    details.open = true;
    details.querySelector('summary')?.setAttribute('aria-expanded', 'true');
    details.classList.remove('is-closing');
    details.classList.add('is-opening');

    const targetPadding = panel.dataset.lpPaddingTop || window.getComputedStyle(panel).paddingTop;
    panel.dataset.lpPaddingTop = targetPadding;
    panel.style.overflow = 'hidden';
    panel.style.height = 'auto';
    panel.style.paddingTop = targetPadding;
    panel.style.opacity = '1';
    const targetHeight = panel.scrollHeight;
    panel.style.height = '0px';
    panel.style.opacity = '0';
    panel.style.paddingTop = '0px';

    panel.offsetHeight;

    window.requestAnimationFrame(() => {
      panel.style.height = `${targetHeight}px`;
      panel.style.paddingTop = targetPadding;
      panel.style.opacity = '1';
    });

    finishAfterTransition(panel, () => {
      details.classList.remove('is-opening');
      resetPanel(details, panel);
    });
  };

  const closeDetails = (details, panel) => {
    details.dataset.lpAnimating = 'true';
    details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    details.classList.remove('is-opening');
    details.classList.add('is-closing');

    const targetPadding = panel.dataset.lpPaddingTop || window.getComputedStyle(panel).paddingTop;
    panel.dataset.lpPaddingTop = targetPadding;
    panel.style.overflow = 'hidden';
    panel.style.height = `${panel.scrollHeight}px`;
    panel.style.opacity = '1';
    panel.style.paddingTop = targetPadding;

    panel.offsetHeight;

    window.requestAnimationFrame(() => {
      panel.style.height = '0px';
      panel.style.opacity = '0';
      panel.style.paddingTop = '0px';
    });

    finishAfterTransition(panel, () => {
      details.open = false;
      details.classList.remove('is-closing');
      resetPanel(details, panel);
    });
  };

  const bindAccordion = (details) => {
    if (details.dataset.lpAccordionBound === 'true') return;
    const summary = details.querySelector('summary');
    if (!summary) return;
    let panel = details.querySelector(panelSelector);
    if (!panel) {
      panel = document.createElement('div');
      panel.className = 'lp-care-accordion__body';
      while (summary.nextSibling) panel.appendChild(summary.nextSibling);
      details.appendChild(panel);
    }

    details.dataset.lpAccordionBound = 'true';
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', String(details.open));
    if (prefersReducedMotion) return;

    details.classList.add('lp-accordion-ready');
    resetPanel(details, panel);

    summary.addEventListener('click', (event) => {
      event.preventDefault();
      if (details.dataset.lpAnimating === 'true') return;

      if (details.open) {
        closeDetails(details, panel);
      } else {
        openDetails(details, panel);
      }
    });
  };

  const bindAll = (root = document) => {
    const scope = root || document;
    scope.querySelectorAll(selector).forEach(bindAccordion);
    scope.querySelectorAll('[data-lp-product-card-size-select]').forEach((select) => {
      if (select.dataset.lpProductCardSizeBound === 'true') return;
      select.dataset.lpProductCardSizeBound = 'true';
      select.addEventListener('change', () => {
        const card = select.closest('.lp-product-card');
        const selectedOption = select.selectedOptions?.[0];
        const url = select.value;
        if (!card || !url) return;
        card.querySelectorAll('[data-lp-product-card-link]').forEach((link) => {
          link.href = url;
        });
        const price = selectedOption?.dataset.price;
        const priceNode = card.querySelector('[data-lp-product-card-price]');
        if (priceNode && price) priceNode.textContent = price;
      });
    });
    scope.querySelectorAll('[data-lp-shop-card-size-select]').forEach((select) => {
      if (select.dataset.lpShopCardSizeBound === 'true') return;
      select.dataset.lpShopCardSizeBound = 'true';
      select.addEventListener('change', () => {
        const card = select.closest('.lp-shop-card');
        const selectedOption = select.selectedOptions?.[0];
        const price = selectedOption?.dataset.price;
        const priceNode = card?.querySelector('[data-lp-shop-card-price]');
        if (priceNode && price) priceNode.textContent = price;
      });
    });
  };

  window.limpideBindComponents = bindAll;

  document.addEventListener('DOMContentLoaded', () => bindAll());
  document.addEventListener('shopify:section:load', (event) => bindAll(event.target));
  document.addEventListener('limpide:page-load', (event) => {
    bindAll(event.detail?.root || document.getElementById('MainContent') || document);
  });
})();
